import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4" }
const _hoisted_3 = { class: "text-body-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "Cereri Documente", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "red-darken-1",
        "prepend-icon": "mdi-file-plus",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogCerere = true))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("Cerere nouă", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
      color: "red-darken-1",
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "cereri" }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("Cereri mele", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "tipuri" }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("Tipuri disponibile", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "cereri" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dataSource,
              "show-borders": true,
              "row-alternation-enabled": true,
              "remote-operations": true
            }, {
              stareCellTemplate: _withCtx(({ data }) => [
                _createVNode(_component_v_chip, {
                  color: _ctx.stareColor(data.data.Stare),
                  size: "small",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.data.Stare), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxColumn, {
                  "data-field": "DataCreare",
                  caption: "Data",
                  "data-type": "datetime",
                  format: "dd.MM.yyyy",
                  width: 130
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Stare",
                  caption: "Stare",
                  width: 130,
                  "cell-template": "stareCellTemplate"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Descriere",
                  caption: "Descriere"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "ObsevatieRaspuns",
                  caption: "Răspuns HR"
                }),
                _createVNode(_component_DxPaging, { "page-size": 15 }),
                _createVNode(_component_DxFilterRow, { visible: true })
              ]),
              _: 1
            }, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "tipuri" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipuri, (tip) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4",
                    key: tip.ID
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        elevation: "2",
                        rounded: "lg"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tip.Denumire), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tip.Cod), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_3, _toDisplayString(tip.Descriere), 1),
                              (tip.NecesitaFisierAngajat)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    size: "small",
                                    color: "blue",
                                    class: "mr-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("Necesită fișier", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (tip.NecesitaAprobare)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 1,
                                    size: "small",
                                    color: "orange"
                                  }, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                      _createTextVNode("Necesită aprobare", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                size: "small",
                                color: "red-darken-1",
                                variant: "tonal",
                                onClick: ($event: any) => (_ctx.selectTip(tip))
                              }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode("Depune cerere", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogCerere,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogCerere) = $event)),
      "max-width": "500",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "red-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-file-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createTextVNode(" Cerere document ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.cerereValid,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cerereValid) = $event)),
                  ref: "cerereForm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.cerereForm.TipCerereDocumentID,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cerereForm.TipCerereDocumentID) = $event)),
                      items: _ctx.tipuri,
                      "item-title": "Denumire",
                      "item-value": "ID",
                      label: "Tip document",
                      variant: "outlined",
                      density: "compact",
                      class: "mb-3",
                      rules: [_ctx.required]
                    }, null, 8, ["modelValue", "items", "rules"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.cerereForm.Descriere,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cerereForm.Descriere) = $event)),
                      label: "Descriere / motivație",
                      variant: "outlined",
                      density: "compact",
                      rows: "3",
                      class: "mb-3"
                    }, null, 8, ["modelValue"]),
                    (_ctx.tipSelectat?.NecesitaFisierAngajat)
                      ? (_openBlock(), _createBlock(_component_v_file_input, {
                          key: 0,
                          modelValue: _ctx.cerereFile,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cerereFile) = $event)),
                          label: "Fișier atașat",
                          variant: "outlined",
                          density: "compact",
                          accept: ".pdf,.doc,.docx,.jpg,.png"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.cerereError)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cerereError), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogCerere = false))
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "red-darken-1",
                  loading: _ctx.cerereLoading,
                  disabled: !_ctx.cerereValid,
                  onClick: _ctx.submitCerere
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("Trimite", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}